import { IconName } from './models'
import ICONS_MAP from './icon-map'
import { Icon } from './Icon'

export type { IconName }
export { ICONS_MAP as iconMap }
export default Icon
